import RestService from "../../../../services/rest.service";
import { IRootScopeService, IScope } from "angular";
import { OnlineServiceMapping, UpdateOnlineServiceMapping, User } from "../../../../data/admin.data";
import angular = require("angular");

require('./admin.users.os.component.scss')


export default class AdminUsersOSComponent {
  public restrict: string;
  public template: any;
  public scope: any;
  public controller: any;
  public controllerAs: string;
  public bindToController: boolean;

  constructor() {
    this.restrict = 'E'
    this.template = require('./admin.users.os.component.html');
    this.scope = {
      user: '=',
    };
    this.controller = UserOSController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}
/* @ngInject */
class UserOSController {
  public restService: RestService;
  public $scope: IScope;
  public $rootScope: IRootScopeService;
  public user: User;
  public isLoading = false;
  onlineServices: OnlineServiceMapping[];

  constructor(restService: RestService, $scope: angular.IScope, $rootScope: angular.IRootScopeService) {
    this.restService = restService;
    this.$scope = $scope;
    this.$rootScope = $rootScope;

    this.$scope.$watch('ctrl.user', (oldValue, newValue: User) => {
      if (angular.isDefined(newValue)) {
        this.user = newValue;
        this.loadAvailableOnlineServices();
      }
    });
  }


  loadAvailableOnlineServices() {
    // only load list if we can actually select one
    if (this.user.hasOnlineService) return;
    this.restService.loadAdminOnlineServices()
      .then(os => this.onlineServices = os.filter(o => !o.inUse))
      .then(() => this.$scope.$applyAsync());
  }

  selectOs(onlineService: OnlineServiceMapping) {
    // not allow this when user already has os
    if (this.user.hasOnlineService) return;
    this.restService.updateOnlineServiceMapping(this.user.id, onlineService.id)
      .then(() => {
        this.user.hasOnlineService = true;
        this.user.onlineServiceName = onlineService.name;
        this.$scope.$applyAsync();
      })
  }

  createOs() {
    // not allow this when user already has os
    if (this.user.hasOnlineService) return;
    this.restService.createOnlineService(this.user.id)
      .then(() => {
        this.user.hasOnlineService = true;
        this.user.onlineServiceName = this.user.name;
        this.$scope.$applyAsync();
      })
  }

}